import React from 'react';
import type { RegistryComponentProps } from '../../pages/registry/componentRegistry';
import { getRegistryData } from '../../pages/registry/componentRegistry';
import { useFormContextOptional } from '../../contexts/FormContext';
import './TimePeriod.css';

const SLUG = 'time-period';

export type TimePeriodValue = 'full' | 'historical' | 'projections';

interface TimePeriodData {
  loading?: boolean;
  defaultTimePeriod?: TimePeriodValue;
}

export default function TimePeriod(props: RegistryComponentProps): React.ReactElement {
  const formContext = useFormContextOptional();
  const data = getRegistryData<TimePeriodData>(props);

  const formValue = formContext?.values?.[SLUG] as TimePeriodValue | undefined;
  const defaultValue = data.defaultTimePeriod ?? 'projections';
  const selectedYear = formValue ?? defaultValue;
  const loading = data.loading ?? false;

  const handleChange = React.useCallback(
    (e: React.ChangeEvent<HTMLSelectElement>) => {
      const value = e.target.value as TimePeriodValue;
      formContext?.setValue(SLUG, value);
    },
    [formContext]
  );

  const description =
    selectedYear === 'full'
      ? 'Showing sum of all years'
      : selectedYear === 'historical'
        ? 'Showing sum of historical data (through 2024)'
        : selectedYear === 'projections'
          ? 'Showing sum of projections (2025+)'
          : 'Showing selected time period';

  return (
    <div className="time-period-container">
      <label htmlFor="time-period-selector">Time Period:</label>
      <select
        id="time-period-selector"
        className="time-period-dropdown"
        value={selectedYear}
        onChange={handleChange}
        disabled={loading}
      >
        <option value="full">Full time series</option>
        <option value="historical">Historical (2015 through 2024)</option>
        <option value="projections">Projections (2025 through 2029)</option>
      </select>
      <div className="time-period-description">{description}</div>
    </div>
  );
}
